import { inject } from '@angular/core';
import { RedirectCommand, Router, type CanActivateFn } from '@angular/router';
import { APP_ROUTES } from '@core/routes';
import { extractPage } from '@core/services/router.service';
import { HANDOFF_QUERY_PARAM } from '@features/analytics/drilldown/criteria-handoff';
import { SearchOptionsService } from '../services/search-options.service';

export const searchCategoryGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const requested = route.queryParamMap.get('category')?.toUpperCase();
    const navigationState = router.currentNavigation()?.extras.state;
    const handoffId = route.queryParamMap.get(HANDOFF_QUERY_PARAM);

    if (handoffId !== null) {
        inject(SearchOptionsService).adoptHandoff(handoffId);

        return new RedirectCommand(
            router.createUrlTree([`/${APP_ROUTES.SEARCH}`], {
                queryParams: { ...route.queryParams, [HANDOFF_QUERY_PARAM]: null },
                fragment: state.root.fragment ?? undefined,
            }),
            { state: navigationState, replaceUrl: true }
        );
    }

    if (requested === 'BUILDINGS') {
        return new RedirectCommand(router.createUrlTree([`/${APP_ROUTES.BUILDING_SEARCH}`]), { state: navigationState });
    }

    if (requested) {
        return true;
    }

    const searchOptionsService = inject(SearchOptionsService);
    const stored = searchOptionsService.searchOptions().category;
    const category = stored === 'BUILDINGS' ? 'SALES' : stored;
    const onSearchPage = extractPage(router.url) === APP_ROUTES.SEARCH;

    return new RedirectCommand(
        router.createUrlTree([`/${APP_ROUTES.SEARCH}`], {
            queryParams: { ...route.queryParams, category: category.toLowerCase() },
            fragment: state.root.fragment ?? undefined,
        }),
        onSearchPage
            ? { state: { shouldKeepSearch: navigationState?.['shouldKeepSearch'] }, replaceUrl: true }
            : { state: navigationState }
    );
};
